import React from 'react';

import { ColumnHeaderSortable } from '../../DataTable/index.jsx';

import Column from './base.jsx';


var columnOptions = {
  id: 'a',
  title: 'Market Cap Ranking'
};


class HeaderColumn extends ColumnHeaderSortable {
  get id() {
    return columnOptions.id;
  }

  get title() {
    return '#';
  }

  get overlayText() {
    return columnOptions.title;
  }
}


class DetailColumn extends React.Component {
  render() {
    return <td>{this.props.row.marketCapRank}</td>;
  }
}


class MarketCapRank extends Column {
  get id() {
    return columnOptions.id;
  }

  get title() {
    return columnOptions.title;
  }

  sortAscending(a, b) {
    // if no market cap is set for the asset, then sort to the bottom.
    if (! a.marketCapRank) {
      return 1;
    }
    if (! b.marketCapRank) {
      return -1;
    }
    if (a.marketCapRank < b.marketCapRank) {
      return -1;
    }
    if (a.marketCapRank > b.marketCapRank) {
      return 1;
    }
    return super.sortAscending(a, b);
  }

  sortDescending(a, b) {
    // if no market cap is set for the asset, then sort to the top.
    if (! a.marketCapRank) {
      return -1;
    }
    if (! b.marketCapRank) {
      return 1;
    }
    if (a.marketCapRank < b.marketCapRank) {
      return 1;
    }
    if (a.marketCapRank > b.marketCapRank) {
      return -1;
    }
    return super.sortDescending(a, b);
  }

  get DetailColumn() {
    return DetailColumn;
  }

  get HeaderColumn() {
    return HeaderColumn;
  }
}


export default MarketCapRank;

